import React, { useState } from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ onSave, onCancel, hasChanges }) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    await onSave();
    setIsSaving(false);
  };

  return (
    <div className="bg-card border-t border-border px-6 py-4 sticky bottom-0 z-10">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row gap-3 sm:justify-end">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isSaving}
          className="sm:w-auto"
        >
          Annuler
        </Button>
        
        <Button
          variant="default"
          iconName="Save"
          iconPosition="left"
          loading={isSaving}
          onClick={handleSave}
          disabled={!hasChanges}
          className="sm:w-auto"
        >
          Enregistrer les modifications
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;